import React from "react";
import Tabla from "js/components/TablaNoticias";

export const AdminNoticias = props => {
  return <Tabla />;
};
